import Accessories from '../Components/Accessories'
import AmazingDeal from '../Components/AmazingDeal'
import Blog from '../Components/Blog'
import Category from '../Components/Category'
import ComingSoon from '../Components/ComingSoon'
import { motion } from "framer-motion"
import Hero from '../Components/Hero'
import Newsletter from '../Components/Newsletter'
import Subhero from '../Components/Subhero'
import './Home.css'

const Home = () => {


  return (
    <motion.div
      exit={{
        x: "-100vw",
       transition:{ ease: 'easeInOut'}
      }}
    >
       
        <Hero />
        <Subhero />
        <Category />
        <AmazingDeal />
        <ComingSoon />
        <Newsletter />
        <Accessories />
        <Blog />
    </motion.div>
  )
}

export default Home